import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { 
  referenceDocumentOptions
} from '../../AttributeData'
import { Cont } from './styled'

const BankGuaranteeInformation = (props) => {

  const { 
    change,
    valueForm,
    bankOwnerOptions,
    // props
    isEdit = false
  } = props

  const checkDueDate = (dueDate) => {
    const firstDate = new Date(valueForm.startDate);
    const secondDate = new Date(dueDate);
    return firstDate<secondDate
  }

  const getFileBGC01 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC01')
  }
  const getFileBGC02 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC02')
  }

  return (
    <StdCard title={<span className='stepTitle'>Bank Guarantee Information</span>}>
      <Cont>
        <RowFields>
          <Field 
            name="bankGuaranteeNumber"
            label="Bank Guarantee No."
            component={FieldInput}
            type={type.text}
            editable={isEdit}
            require
          />
          <Field 
            name="bankOwner"
            label="Bank Owner"
            component={FieldInput}
            options={bankOwnerOptions.data}
            loading={bankOwnerOptions.loading}
            type={type.select}
            editable={isEdit&&valueForm.documentType=='Original'}
            require
          />
        </RowFields>
        <RowFields>
          <RowFields>
            <Field 
              name="startDate"
              label="Start Date"
              component={FieldInput}
              type={type.date}
              editable={isEdit}
              require
            />
            <Field 
              name="dueDate"
              label="Due Date"
              component={FieldInput}
              type={type.date}
              editable={isEdit&&!valueForm.isNoExpireDate}
              specialOnChange={(value)=>{
                if(value){
                  if(!checkDueDate(value)){
                    change('formBGCompany','dueDate','')
                  }
                }
              }}
              require={!valueForm.isNoExpireDate}
            />
          </RowFields>
          <RowFields>
            <Field 
              name="isNoExpireDate"
              label="No Expire Date"
              component={FieldInput}
              type={type.checkbox}
              editable={isEdit}
              fieldInputStyle={{justifyContent:'center'}}
              specialOnChange={(value)=>{
                if(value){
                  change('formBGCompany','dueDate','')
                  change('formBGCompany','periodDay','')
                }
              }}
              className='halfRow'
            />
          </RowFields>
        </RowFields>
        {valueForm.returnDate?
        <RowFields>
          <Field 
            name="returnDate"
            label="Return Date"
            component={FieldInput}
            type={type.date}
            editable={false}
            className='halfRow'
          />
        </RowFields>:null}
        <RowFields>
          <Field 
            name="referenceDocumentType"
            label="Original Reference Document"
            component={FieldInput}
            options={referenceDocumentOptions}
            type={type.select}
            editable={false}
            className='halfRow'
            require
          />
        </RowFields>
        <RowFields>
          {valueForm.referenceDocumentType=='contract'?
          <React.Fragment>
            <Field 
              name="referenceContractDate"
              label="Contract Date"
              component={FieldInput}
              type={type.date}
              editable={false}
              require
            />
            <Field 
              name="referenceContractNumber"
              label="Contract Number"
              component={FieldInput}
              type={type.text}
              editable={false}
            />
          </React.Fragment>
          :
          <Field 
            name="referencePurchaseOrderNumber"
            label="Purchase Order Number"
            component={FieldInput}
            type={type.text}
            editable={false}
            className='halfRow'
            require
          />
          }
        </RowFields>
        <RowFields style={{justifyContent:'start'}}>
          {valueForm.referenceDocumentType=='contract'?
            <Field 
              name='bgc01' 
              label='Contract (PDF)'
              type={type.file}
              editable={false}
              component={FieldInput} 
              oldFiles={getFileBGC01()}
              showOldFile
            />
            :
            <Field 
              name='bgc02' 
              label='Purchase Order (PDF)' 
              type={type.file}
              editable={false}
              component={FieldInput} 
              oldFiles={getFileBGC02()}
              showOldFile
            />
          }        
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {attachments:[]},
    bankOwnerOptions: state.bg.bankOwners,
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeInformation)
